/**
 * Class APIService
 * Represents a base class for api services abstraction
 * Note: Requires the authentication header in axios
 * */
export default class APIService{

    static API_URL = process.env.VUE_APP_URL_API_SERVER;

    constructor(){}
}